import notFound from "./components/Main.vue";

export default [{ path: "/404", name: "notFound", component: notFound }];
